import React from 'react';
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import PublicHeader from "./Common/PublicHeader";
import SubmitReviewModal from "../pages/Marketing/ClientReviews/SubmitReview/SubmitReviewModal";

const PublicRouterBase = () => {
    return (
        <div>
            <Router>
                <PublicHeader/>
                <main className="sl-main sl-mt-8">
                    <Routes>
                        <Route exact path="/public/marketing/leave-review/:token?" element={<SubmitReviewModal/>}/>
                    </Routes>
                </main>

            </Router>
        </div>
    );
};
export default PublicRouterBase;
